export const TREATMENT_MODALITY = [
  {
    label: "Direct",
    value: "Direct",
  },
  {
    label: "Caregiver Mediated",
    value: "Caregiver Mediated",
  },
  {
    label: "Caregiver Training Only",
    value: "Caregiver Training Only",
  },
];

export const IQ_TEST = [
  {
    label: "Wechsler Intelligence Scale for Children (WISC-V)",
    value: "Wechsler Intelligence Scale for Children (WISC-V)",
  },
  {
    label: "Stanford-Binet Intelligence Scales (SB-5)",
    value: "Stanford-Binet Intelligence Scales (SB-5)",
  },
  {
    label: "Kaufman Brief Intelligence Test (KBIT-2)",
    value: "Kaufman Brief Intelligence Test (KBIT-2)",
  },
  {
    label: "N/A",
    value: "n/a",
  },
];

export const CARS2_TYPE = [
  {
    label: "CARS-2 ST",
    value: "CARS-2 ST",
  },
  {
    label: "CARS-2 HF",
    value: "CARS-2 HF",
  },
  {
    label: "N/A",
    value: "n/a",
  },
];

export const ADDITIONAL_DIAGNOSES = [
  {
    code: "F34.8",
    label: "Other Persistent Mood Disorder",
  },
  {
    code: "F34.81",
    label: "Disruptive Mood Dysregulation Disorder",
  },
  {
    code: "F39",
    label: "Unspecified Mood Disorder",
  },
  {
    code: "F40.10",
    label: "Social Anxiety Disorder",
  },
  {
    code: "F41.1",
    label: "Generalized Anxiety Disorder",
  },
  {
    label: "Obsessive-Compulsive Disorder (OCD)",
    code: "F42.0",
  },
  {
    code: "F43.10",
    label: "Post-Traumatic Stress Disorder",
  },
  {
    code: "F43.22",
    label: "Adjustment Disorder with Anxiety",
  },
  {
    code: "F50.84",
    label: "Avoidant/ Restrictive Food Intake Disorder (ARFID)",
  },
  {
    code: "F70",
    label: "Mild Intellectual Disability",
  },
  {
    code: "F71",
    label: "Moderate Intellectual Disability",
  },
  {
    code: "F72",
    label: "Severe Intellectual Disability",
  },
  {
    code: "F73",
    label: "Profound Intellectual Disability",
  },
  {
    code: "F79",
    label: "Unspecified Intellectual Disability",
  },
  {
    code: "F80.2",
    label: "Language Disorder",
  },
  {
    code: "F80.9",
    label: "Unspecified Communication Disorder",
  },
  {
    code: "F82",
    label: "Developmental Coordination Disorder",
  },
  {
    code: "F84.0",
    label: "Autism Spectrum Disorder",
  },
  {
    code: "F88",
    label: "Global Developmental Delay",
  },
  {
    code: "F90.0",
    label: "ADHD, Predominantly Inattentive Presentation",
  },
  {
    code: "F90.1",
    label: "ADHD, Predominantly Hyperactive/ Impulsive Presentation",
  },
  {
    code: "F90.2",
    label: "ADHD, Combined Presentation",
  },
  {
    code: "F90.8",
    label: "Other Specified ADHD",
  },
  {
    code: "F90.9",
    label: "Unspecified ADHD",
  },
  {
    code: "F91.3",
    label: "Oppositional Defiant Disorder (ODD)",
  },
  {
    code: "F93.0",
    label: "Separation Anxiety Disorder",
  },
  {
    code: "F96.9",
    label: "Unspecified Childhood Disorder of Psychological Development",
  },
  {
    code: "F98.8",
    label: "Other Specified Behavioral and Emotional Disorders with Onset in Childhood",
  },
  {
    code: "F98.9",
    label: "Other Specified Behavioral and Emotional Disorders",
  },
  {
    code: "asperger syndrome",
    label: "* Asperger's Syndrome (select this only if referenced in diagnostic report)",
  },
  {
    code: "major depressive disorder",
    label: "Major Depressive Disorder (any presentation)",
  },
  {
    code: "pathological demand avoidance",
    label: "Pathological Demand Avoidance (PDA)",
  },
  {
    code: "sensory processing disorder",
    label: "Sensory Processing Disorder (SPD)",
  },
  {
    code: "n/a",
    label: "N/A",
  },
];

export const ASD_SEVERITY = [
  {
    label: "Level 1",
    value: "1",
  },
  {
    label: "Level 2",
    value: "2",
  },
  {
    label: "Level 3",
    value: "3",
  },
  {
    label: "N/A",
    value: "n/a",
  },
];

export const MEDICAL_DIAGNOSES = [
  {
    label: "Asthma",
    value: "Asthma",
  },
  {
    label: "Autoimmune Disorder",
    value: "Autoimmune Disorder",
  },
  {
    label: "Cerebral Palsy",
    value: "Cerebral Palsy",
  },
  {
    label: "Chronic Constipation",
    value: "Chronic Constipation",
  },
  {
    label: "Diabetes",
    value: "Diabetes",
  },
  {
    label: "Down Syndrome",
    value: "Down Syndrome",
  },
  {
    label: "Ehlers-Danlos Syndrome / Joint Hypermobility",
    value: "Ehlers-Danlos Syndrome / Joint Hypermobility",
  },
  {
    label: "Epilepsy / Seizure Disorders",
    value: "Epilepsy / Seizure Disorders",
  },
  {
    label: "Food Allergies / Sensitivities",
    value: "Food Allergies / Sensitivities",
  },
  {
    label: "Fragile X Syndrome",
    value: "Fragile X Syndrome",
  },
  {
    label: "Gastroesophageal Reflux Disease (GERD)",
    value: "Gastroesophageal Reflux Disease (GERD)",
  },
  {
    label: "Hypotonia",
    value: "Hypotonia",
  },
  {
    label: "Irritable Bowl Syndrome (IBS)",
    value: "Irritable Bowl Syndrome (IBS)",
  },
  {
    label: "Migraine / Chronic Headaches",
    value: "Migraine / Chronic Headaches",
  },
  {
    label: "Mitochondrial Disorders",
    value: "Mitochondrial Disorders",
  },
  {
    label: "Rett Syndrome",
    value: "Rett Syndrome",
  },
  {
    label: "Seasonal Allergies",
    value: "Seasonal Allergies",
  },
  {
    label: "Sleep Disorder",
    value: "Sleep Disorder",
  },
  {
    label: "Tics / Tourette Syndrome",
    value: "Tics / Tourette Syndrome",
  },
  {
    label: "Tuberous Sclerosis Complex (TSC)",
    value: "Tuberous Sclerosis Complex (TSC)",
  },
  {
    label: "N/A",
    value: "n/a",
  },
];
